import React, { useEffect, useRef, useState } from "react";
import "./gallery.scss";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from "@mui/material";
import { toast } from "react-toastify";

interface EditGalleryProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (data: FormData) => void;
    initialGallery: any;
}

const EditGallery: React.FC<EditGalleryProps> = ({
    isOpen,
    onClose,
    onSubmit,
    initialGallery,
}) => {
    const [galleryPreview, setGalleryPreview] = useState<any>(initialGallery);
    const [galleryFile, setGalleryFile] = useState<any>();
    const galleryInputRef = useRef<HTMLInputElement | null>(null);



    useEffect(() => {
        setGalleryPreview(initialGallery);
          if(initialGallery.isVideo){
            setGalleryFile({type:"video/mp4"})
          }
          else{
            setGalleryFile({type:"image/"})
          }
        if (galleryInputRef.current) galleryInputRef.current.value = "";
    }, [initialGallery, isOpen]);

    const handleGalleryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const allowed = [
            "image/jpeg",
            "image/png",
            "image/jpg",
            "video/mp4",
        ];

        if (!allowed.includes(file.type)) {
            toast.error("Only .jpg, .jpeg, .png, .mp4 are allowed");
            galleryInputRef.current.value = ""
            return;
        }

        setGalleryFile(file);
        const url = URL.createObjectURL(file);
        setGalleryPreview({"gallery":url});
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        const formData = new FormData();
        let hasChanges = false;

        if (galleryFile) {
            console.log(galleryFile)
            formData.append("file", galleryFile);
            hasChanges = true;
        }

        if (!hasChanges) {
            toast.info("No changes detected");
            return;
        }

        onSubmit(formData);
        onClose();
    };

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{ style: { padding: 20, borderRadius: 12 } }}
        >
            <DialogTitle
                style={{
                    fontFamily: "Karbon-semi",
                    fontSize: 22,
                    textAlign: "center",
                    paddingBottom: 0,
                }}
            >
                Edit Gallery
            </DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit} style={{ marginTop: 10 }}>

                    <label
                        style={{
                            fontFamily: "Karbon-medium",
                            marginTop: 15,
                            display: "block",
                            marginBottom: 6,
                        }}
                    >
                        Gallery
                    </label>
                    <input
                        type="file"
                        accept="image/*,video/*"
                        onChange={handleGalleryChange}
                        ref={galleryInputRef}

                        style={{ display: "block", marginBottom: 10 }}
                    />
                    <span
                        style={{
                            fontSize: "12px",
                            color: "#666",
                            fontFamily: "karbon-semi",
                            display: "block",
                            marginTop: 8,
                            marginBottom: 10,
                        }}
                    >
                        Accepted formats: JPG, JPEG, PNG, MP4
                    </span>
                    {galleryPreview && (
                        galleryFile && galleryFile.type.startsWith("video/") ? (
                            <video
                                src={galleryPreview.gallery}
                                controls
                                style={{
                                    width: "100%",
                                    maxHeight: 180,
                                    objectFit: "contain",
                                    borderRadius: 8,
                                    marginBottom: 10,
                                }}
                                className="modal-gallery-preview"
                            />
                        ) : (
                            <img
                                src={galleryPreview.gallery}
                                alt="Gallery Preview"
                                style={{
                                    width: "100%",
                                    maxHeight: 180,
                                    objectFit: "contain",
                                    borderRadius: 8,
                                    marginBottom: 10,
                                }}
                                className="modal-gallery-preview"
                            />
                        )
                    )}
                    {/* Buttons */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 10,
                            marginTop: 20,
                        }}
                    >
                        <button
                            type="submit"
                            style={{
                                fontFamily: "Karbon-medium",
                                fontSize: 18,
                                background: "#D9490C",
                                color: "white",
                                border: "none",
                                borderRadius: 10,
                                padding: "10px 24px",
                                cursor: "pointer",
                            }}
                        >
                            Update
                        </button>
                        <button
                            type="button"
                            onClick={onClose}
                            className="btn btn-secondary"
                            style={{
                                fontFamily: "Karbon-medium",
                                fontSize: 18,
                                marginLeft: 10,
                                padding: "10px 24px",
                                cursor: "pointer",
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </DialogContent>
        </Dialog>

    );
};

export default EditGallery;
